import { useLocation } from "@tanstack/react-router";

type Section = {
  match: (p: string) => boolean;
  emoji: string;
  title: string;
};

const startsWithAny = (p: string, prefixes: string[]) =>
  prefixes.some((prefix) => p === prefix || p.startsWith(prefix + "/"));

const SECTIONS: Section[] = [
  
  {
    match: (p) =>
      startsWithAny(p, [
        "/my-healing-journey",
        "/how-to-start",
        "/breathing",
        "/grounding",
        "/somatic",
        "/yoga",
        "/sounds",
        "/aromatherapy",
        "/acts-of-self-care",
        "/self-love",
        "/affirmations",
        "/bilateral",
        "/tapping",
        "/journal",
        "/dreams",
        "/shadow-work",
        "/sleep",
        "/guided-journal",
        "/check-in",
        "/mood",
        "/favorites",
      ]),
    emoji: "🌿",
    title: "How To Start",
  },
  {
    match: (p) => startsWithAny(p, ["/dashboard"]),
    emoji: "🏠",
    title: "Dashboard",
  },
  {
    match: (p) =>
      startsWithAny(p, [
        "/library",
        "/therapy-approaches",
        "/resources",
        "/courses",
        "/quiz",
        "/roadmap",
        "/guide",
        "/holistic-wellbeing",
        "/integrate",
      ]),
    emoji: "📚",
    title: "Recovery Library",
  },
  {
    match: (p) => startsWithAny(p, ["/community", "/therapists"]),
    emoji: "👥",
    title: "Community",
  },
  {
    match: (p) => startsWithAny(p, ["/events"]),
    emoji: "🎟️",
    title: "Live Events",
  },
  {
    match: (p) => startsWithAny(p, ["/support", "/help", "/faq", "/crisis"]),
    emoji: "🛟",
    title: "Support & Crisis Resources",
  },
  {
    match: (p) => startsWithAny(p, ["/about"]),
    emoji: "🌱",
    title: "About Recovery Trauma™",
  },
  {
    match: (p) => startsWithAny(p, ["/membership", "/pricing", "/founding"]),
    emoji: "✨",
    title: "Membership",
  },
  {
    match: (p) => startsWithAny(p, ["/login", "/signup", "/admin-login", "/auth"]),
    emoji: "🔐",
    title: "Sign in",
  },
];

export function SectionTitleBar() {
  const { pathname } = useLocation();
  const section = SECTIONS.find((s) => s.match(pathname));
  if (!section) return null;

  return (
    <div className="lg:hidden">
      <div className="mx-auto flex max-w-[640px] items-center gap-2 px-5 py-2">
        <span aria-hidden className="text-base">
          {section.emoji}
        </span>
        <p className="truncate font-display text-sm font-semibold tracking-wide text-foreground">
          {section.title}
        </p>
      </div>
    </div>
  );
}
